export default "__VITE_ASSET__B4g4HzSa__"